module.exports = __webpack_public_path__ + "img/1993.a7daa9bc.svg";